/**
 * The theme variables for commonly used CSS in Iterable designs
 * Figma: https://www.figma.com/file/36q2en2Fb6AAepdm1I6NGn/Design-system?node-id=62%3A18043
 *
 * NOTE: because the legacy app is configured as a base unit size of 14px, the sizing units are REM units assuming that
 */
import * as spacings from './spacing';

export * from './borderRadius';
export * from './borderWidth';
export * from './focusRings';
export * from './colors';
export * from './globalStyles';
export * from './motion';
export * from './shadows';
export * from './theme';
export * from './types';
export * from './typography';
export const spacing = spacings;
